import {Component, inject, Signal} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ContentComponent} from '../../components/content/content.component';
import {Store} from "@ngrx/store";
import {selectUISettings} from "../../store/selectors/app.selectors";
import {UISettings} from "../../services/ssession.service";

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [
    RouterModule,
    ContentComponent
  ],
  templateUrl: './not-found.component.html',
  styles: `p {
    padding-top: 100px;
    padding-bottom: 100px;
    display: block;
    text-align: center;
    font-size: 2rem;
  }
  `
})
export class NotFoundComponent {

  private store$: Store = inject(Store);

  public uiSettings: Signal<UISettings | null> = this.store$.selectSignal(selectUISettings);
}
